  import {
    BuildingOfficeIcon,
    EnvelopeIcon,
    MagnifyingGlassIcon,
    PencilIcon,
    PhoneIcon,
    TrashIcon,
    UserCircleIcon,
    EyeIcon,
    SparklesIcon,
    WrenchScrewdriverIcon 
  } from "@heroicons/react/24/outline";
  import { Link } from "react-router-dom";
  import VpnKeyIcon from '@mui/icons-material/VpnKey';
  import { Box, Button, Divider, IconButton, Modal, Tooltip, Typography, Avatar } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import toast from "react-hot-toast";
  import { useAppDispatch, useAppSelector } from "../../store";
  import { selectBranches } from "../branch/branchSlice";
  import {
    deleteUser,
    fetchUsers,
    selectSelectedUser,
    selectUserError,
    selectUserLoading,
    selectUsers,
    selectUserPagination,
    setSelectedUser,
    toggleUserStatus
  } from "./userSlice";
  import { User } from "./user";
  // import CreateUserModal from "./CreateUserModal";
  import EditUserModal from "./EditUserModal";
  import FormControl from "@mui/material/FormControl";
  import { InputLabel, MenuItem, Select } from "@mui/material";
  import SearchBar from "../../components/searchbar";
  import { usePermission } from "../../components/common/PermissionGuard";
  // import CreateUserModal from "./CreateUserModal";
import { USE_STUB_DATA } from "../../config/stubData";
import Pagination from "../../components/common/Pagination";
import { PAGINATION_OPTIONS } from "../../constants/pagination";
import CloseConfirmationDialogue from "../../components/common/__tests__/CloseConfirmationDialogue";
import UserQRCode from "../../components/UserQRCode";
import { TimelineDot } from "@mui/lab";
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import ChangePasswordModal from "./ChangePasswordModal";
import { formatStatusText,capitalizeWords } from "../../utils/formatters"
import ChangeStatusConfirmation from "../../components/common/__tests__/ChangeStatusConfirmation";
import { config } from "../../config/environment";
import { UPLOAD_BASE_PATH } from "../../config/upload";


const USER_ROLES = [
    { value: "admin", label: "Admin" },
    { value: "manager", label: "Manager" },
    { value: "staff", label: "Staff" },
  ];

  const UserManager = ({
    showCreateModal = false,
    setShowCreateModal,
    searchQuery,
    filterType,
    selectedBranch, // Accept selectedBranch
    setSelectedBranch, // Accept setSelectedBranch

  }: {
    showCreateModal: boolean;
    setShowCreateModal: (show: boolean) => void;
    searchQuery: string; // Add searchQuery as a prop
  //  setSearchQuery: (query: string) => void; // Add setSearchQuery as a prop
    filterType: "all" | "active" | "inactive";
    selectedBranch: string | null; // ✅ Add this line
    setSelectedBranch: (branch: string | null) => void; // ✅ And this line
  }) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const users = useAppSelector(selectUsers);
    const branches = useAppSelector(selectBranches);
    const isLoading = useAppSelector(selectUserLoading);
    const error = useAppSelector(selectUserError);
    const pagination = useAppSelector(selectUserPagination);
    // const selectedUser = useAppSelector(selectSelectedUser);
    const[selectedUser, setSelectedUser] = useState<User | null>(null);
    const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingUser, setEditingUser] = useState<User | null>(null);
    const [iscreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState<"create" | "edit">("create");
    const [modalUser, setModalUser] = useState<User | null>(null);
    const [closeDialog, setCloseDialog] = useState(false);
    const [isFormFilled, setIsFormFilled] = useState(false);
    const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
    const [selectedUserForStatus, setSelectedUserForStatus] = useState<User | null>(null);
    const [profilePreview, setProfilePreview] = useState<string | null>(null);

    const handleOpenModal = (id: string) => setSelectedUserId(id);
    const handleCloseModal = () => setSelectedUserId(null);

     const handleFormDirty = (isFilled: boolean) => {
      setIsFormFilled(isFilled);
    };
    // useEffect(() => {
    //   console.log("isFormFilled from parent: ",isFormFilled)
    //   if(isFormFilled == true){
    //      setCloseDialog(true);
    //   }
    // },[isFormFilled])

    useEffect(() => {
      console.log('======>Users',users)
    },[users])

   

    const handleConfirmStatusChange = (user: User) => {
      const updatedStatus = user.status === 'active' ? 'inactive' : 'active';
      dispatch(toggleUserStatus({ id: user.id, status: updatedStatus }));
      handleCloseModal();
    };   

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      console.log("Search Query:", e.target.value); // Debugging log
     // setSearchQuery(e.target.value); // Update the search query state
    };

    // Pagination handlers
    const handlePageChange = (page: number) => {
      dispatch(fetchUsers({
        page,
        limit: pagination.limit,
        search: searchQuery,
        status: filterType === "all" ? "" : filterType,
        branchId: selectedBranch || undefined,
      }));
    };

    const handleItemsPerPageChange = (itemsPerPage: number) => {
      dispatch(fetchUsers({
        page: 1, // Reset to first page when changing items per page
        limit: itemsPerPage,
        search: searchQuery,
        status: filterType === "all" ? "" : filterType,
        branchId: selectedBranch || undefined,
      }));
    };

    const canEdit = usePermission("users","update");

    const handleDelete = async (userId: string) => {
      if (!window.confirm("Are you sure you want to delete this user?")) return;

      try {
        await dispatch(deleteUser(userId)).unwrap();
        toast.success("User deleted successfully");
      } catch (error) {
        toast.error("Failed to delete user");
      }
    };
    useEffect(() => {
      if (selectedUser) {
        setShowCreateModal(true);
      }
    }, [selectedUser]);

    // const handleEdit = (user: User) => {
    //   setEditingUser(user);
    //   setShowEditModal(true);
    // };
    
    const handleCloseEditModal = () => {
      setShowEditModal(false);
      setEditingUser(null);
      if(!USE_STUB_DATA){
        dispatch(fetchUsers({
          page: pagination.page,
          limit: pagination.limit,
          search: searchQuery,
          status: filterType === "all" ? "" : filterType,
          branchId: selectedBranch || undefined,
        })); // Fetch users again after closing modal
      }
    };
    
    console.log("Selected User of edit:", selectedUser);

    const handleCloseCreateModal = () => {
      // dispatch(setSelectedUser(null));
      setShowCreateModal(false);
      setSelectedUserId(null); // Reset selected user ID when closing modal
      setSelectedUser(null); // Reset selected user
      if(!USE_STUB_DATA){
        dispatch(fetchUsers({
          page: pagination.page,
          limit: pagination.limit,
          search: searchQuery,
          status: filterType === "all" ? "" : filterType,
          branchId: selectedBranch || undefined,
        })); // Fetch users again after closing modal
      }
    };

    const handleViewDetails = (userId: string) => {
      console.log('navigate to detail function')
      navigate(`/users/${userId}`);
    };

    // Open modal for create
  

  // Open modal for edit
  const handleEdit = (user: User) => {
    setModalMode("edit");
    setModalUser(user);
    setShowUserModal(true);
  };

  // Close modal
  const handleCloseUserModal = () => {
    setShowUserModal(false);
    setModalUser(null);
    if(!USE_STUB_DATA){
      dispatch(fetchUsers({
        page: pagination.page,
        limit: pagination.limit,
        search: searchQuery,
        status: filterType === "all" ? "" : filterType,
        branchId: selectedBranch || undefined,
      }));
    }
  };


    // No need for client-side filtering since we're using server-side filtering
    const filteredUsers = users;   

    // Global error is now only for fetch operations, not individual CRUD operations
    // Individual operation errors are handled via toast notifications


    const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  console.log("Filtered Users:", filteredUsers);
  console.log("selectedUser after:", selectedUser);

  function removeLastEndpoint(url) {
    // Remove trailing slash if present, then remove everything after the last "/"
    return url.replace(/\/+$/, "").substring(0, url.replace(/\/+$/, "").lastIndexOf("/"));
  }

  useEffect(() => {
       console.log(`url----- ${removeLastEndpoint(config.API_URL)}${UPLOAD_BASE_PATH}/${filteredUsers[0]?.avatarUrl}`);
   
     },[filteredUsers])

    return (
      <div>
        {/* User Cards Grid */}
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
            {filteredUsers.map((user) => (
              <div
                key={`${user.id}-${user.status}`}
                className="flex flex-col justify-between hover:shadow-lg transition-shadow cursor-pointer bg-white dark:bg-gray-900 rounded-2xl shadow-md pt-2 h-full"
                onClick={() => handleViewDetails(user.id)}
              >
                 {/* Top Content */}
                <div className="flex-1 flex flex-col justify-start ml-1 pr-4 pl-4">
                  <div className="flex items-center justify-between mb-4">
                    
                    {/* Left: Avatar + Name */}
                    <div className="flex items-center space-x-3">
                      <Avatar
                        src={user?.avatarUrl ? `${removeLastEndpoint(config.API_URL)}${UPLOAD_BASE_PATH}/${user.avatarUrl}` : undefined}
                        sx={{ width: 40, height: 40, fontSize: '1rem' }}
                      >
                        {user.firstName?.[0] || ""}
                      </Avatar>
                      <Tooltip 
                        title={capitalizeWords(user.firstName || "")}
                        arrow
                      >
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white wrap truncate max-w-[200px]">
                        {capitalizeWords(user.firstName || "")}
                      </h3>
                      </Tooltip>
                      <span>
                      {user.status  === 'active'  ? 
                      <TimelineDot sx={{
                        width: 8,
                        height: 8,
                        padding: 0,           
                        margin: 0,            
                      }} variant="filled" color='success' /> : <TimelineDot sx={{
                        width: 8,
                        height: 8,
                        padding: 0,           
                        margin: 0,            
                      }} variant="filled" color='error' />}
                    </span>
                    </div>

                    {/* Right: Status Badge */}
                    {/* <Tooltip title="Change Password">
                    <IconButton
                      color="primary"
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log("Change Password clicked for user:");
                        setModalMode("edit");
                        setModalUser(user);
                        setChangePasswordModalOpen(true);
                      }}
                      
                      // sx={{
                      //   "&:hover": {
                      //     backgroundColor: "primary.light",
                      //   },
                      // }}
                    >
                      <LockResetOutlinedIcon />
                    </IconButton>
                    </Tooltip> */}
                    <div className="flex items-center justify-center "
                      onClick={(e) => e.stopPropagation()}
                    >
                      {user?.id && user.id !== undefined && user.status === 'active' && (
                        <UserQRCode
                          userId={user.id}
                          userName={`${user.firstName || ''} ${user.lastName || ''}`.trim()}
                          userEmail={user.email}
                          variant="inline"
                          size="small"
                          showProfileUrl={true}
                        />
                      )}
                    </div>

                  </div>

                  <div className="space-y-3">
                    <div className="flex flex-wrap justify-between gap-2">
                      <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 flex-1 min-w-[150px]">
                        <UserCircleIcon className="h-5 w-5 mr-2" />
                        <span className="truncate">
                          { formatStatusText(
                            user.role === "worker"
                            ? "Operator"
                            : user.role === "sales"
                            ? "Sales Person"
                            : USER_ROLES.find((r) => r.value === user.role)?.label || user.role)
                          }
                        </span>
                      </div>
                      <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 flex-1 min-w-[150px]"
                      onClick={(e) => {
                        e.stopPropagation(); 
                      }}
                      >
                        <PhoneIcon className="h-5 w-5 mr-2" />
                        {user.phone ? (
                          <a href={`tel:${user.phone}`} 
                          title={user.phone}className="hover:text-blue-600 truncate block max-w-[140px]">
                            {user.phone}
                          </a>
                        ) : (
                          "Not available"
                        )}
                      </div>
                      
                    </div>

                    <div className="flex flex-wrap justify-between gap-2">
                      {/* <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 flex-1 min-w-[150px]"
                      onClick={(e) => {
                        e.stopPropagation(); 
                      }}
                      >
                        <PhoneIcon className="h-5 w-5 mr-2" />
                        {user.phone ? (
                          <a href={`tel:${user.phone}`} 
                          title={user.phone}className="hover:text-blue-600 truncate block max-w-[140px]">
                            {user.phone}
                          </a>
                        ) : (
                          "Not available"
                        )}
                      </div> */}
                      {
                        user.branchId && (
                          <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 flex-1 min-w-[150px]">
                            <BuildingOfficeIcon className="h-5 w-5 mr-2" />
                            <span className="truncate">
                              {branches.find((b: any) => b.id === user.branchId)?.name ||
                                "-"}
                            </span>
                          </div> 
                        )
                      }
                       
                      {/* <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 flex-1 min-w-[150px]"
                      onClick={(e) => {
                        e.stopPropagation(); 
                      }}
                      >
                        <EnvelopeIcon className="h-5 w-5 mr-2" />
                        {user.email ? (
                          <a
                            href={`mailto:${user.email}`}
                            className="hover:text-blue-600 "
                          >
                            {user.email}
                          </a>
                        ) : (
                          "Not available"
                        )}
                      </div>                      */}
                    </div>

                    <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 flex-1 min-w-[150px]">
                      <WrenchScrewdriverIcon className="h-4 w-4 mr-2 flex-shrink-0" />
                      <span
                        className="truncate"
                        title={user.stages?.length ? user.stages.join(", ") : "-"} // Tooltip shows full text
                      >
                        {user.stages?.length ? user.stages.join(", ") : "-"}
                      </span>
                    </div>

                  </div>
                </div>
                
                <div className="mt-3">
                  <Divider className="dark:border-gray-600" />
                  <div className="grid grid-cols-3 divide-x divide-gray-200 dark:divide-gray-600 h-12">
                    
                    {canEdit && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(user);
                        }}
                        className="flex items-center justify-center px-4 py-3 text-sm text-primary-600 hover:bg-primary-50 hover:rounded-bl-2xl dark:text-primary-400 dark:hover:bg-primary-900/10 transition-colors"
                        disabled={isLoading}
                      >
                        <PencilIcon className="h-4 w-4 mr-1.5" />
                        Edit
                      </button>
                    )}
                    
                    <div className="flex items-center justify-center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {/* {user?.id && user.id !== undefined && (
                        <UserQRCode
                          userId={user.id}
                          userName={`${user.firstName || ''} ${user.lastName || ''}`.trim()}
                          userEmail={user.email}
                          variant="inline"
                          size="small"
                          showProfileUrl={true}
                        />
                      )} */}
                      <Tooltip title="Change Password">
                        <IconButton
                          sx={{color: "#337aecff", }}
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log("Change Password clicked for user:");
                            setModalMode("edit");
                            setModalUser(user);
                            setChangePasswordModalOpen(true);
                          }}
                          
                        >
                          {/* <LockResetOutlinedIcon /> */}
                          <VpnKeyOutlinedIcon/>
                        </IconButton>
                      </Tooltip>
                    </div>
                    
                    {/* <div className="flex items-center justify-center px-4 py-1"> */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          // handleConfirmStatusChange(user);
                          setSelectedUserForStatus(user);
                          setIsStatusModalOpen(true);
                        }}
                        className={`flex items-center justify-center px-4 py-3 text-sm transition-colors hover:rounded-br-2xl
                          ${user.status === "active" 
                            ? "text-green-600 hover:bg-green-50 dark:text-green-500 dark:hover:bg-green-900/20"
                            : "text-red-600 hover:bg-red-50 dark:text-red-500 dark:hover:bg-red-900/20"
                          }`}
                      >
                        {user.status === "active" ? "Active" : "Inactive"}
                      </button>
                    {/* </div> */}
                  </div>
                </div>

                {/* Modal specific to this user */}
                <Modal
                  open={selectedUserId === user.id}
                  onClose={handleCloseModal}
                  aria-labelledby="modal-title"
                  aria-describedby="modal-description"
                >
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: 400,
                      bgcolor: 'background.paper',
                      border: '2px solid #000',
                      boxShadow: 24,
                      p: 4,
                    }}
                  >
                    <Typography id="modal-title" variant="h6">
                      Confirm Status Change
                    </Typography>
                    <Typography id="modal-description" sx={{ mt: 2 }}>
                      Are you sure you want to {user.status ? "de-activate" : "activate"} {user.firstName}?
                    </Typography>
                    <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                      <Button variant="outlined" onClick={handleCloseModal}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color={user.status ? "error" : "primary"}
                        onClick={() => handleConfirmStatusChange(user)}
                      >
                        {user.status ? "De-Activate" : "Activate"}
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              </div>

            ))}
            {filteredUsers.length === 0 && !isLoading && (
              <div className="col-span-full text-center py-8 text-gray-500 dark:text-gray-400">
                No users found
              </div>
            )}
          </div>
        </div>

       {isStatusModalOpen && selectedUserForStatus && (
        <ChangeStatusConfirmation
          open={isStatusModalOpen}
          onClose={() => {
            setIsStatusModalOpen(false);
            setSelectedUserForStatus(null);
          }}
          onConfirm={() => {
            handleConfirmStatusChange(selectedUserForStatus);
            setIsStatusModalOpen(false);
            setSelectedUserForStatus(null);
          }}
          title="Change Status"
          message={`Are you sure you want to change status to ${selectedUserForStatus.status === 'active' ? 'Inactive' : 'Active'}?`}
        />
      )} 

        {/* Pagination */}
        {pagination.total > 0 && (
          <Pagination
            currentPage={pagination.page}
            totalPages={pagination.pages}
            totalItems={pagination.total}
            itemsPerPage={pagination.limit}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
            showItemsPerPage={true}
            itemsPerPageOptions={PAGINATION_OPTIONS}
          />
        )}      
        {/* Modals */}
        {/* <CreateUserModal
          isOpen={showCreateModal}
          onClose={handleCloseCreateModal}
          user={selectedUser as User}
        /> */}
        {/* {showUserModal && ( */}
          <EditUserModal
            isOpen={showUserModal}
            onRequestClose={(hasData) => {
             
              if (hasData) {
                setCloseDialog(true)
              } else {
                
                setShowUserModal(false);
                setModalUser(null);
              }
            }}
            onSuccess={() => {
              setShowUserModal(false);
              setModalUser(null);
              setIsFormFilled(false);
              if(!USE_STUB_DATA){
                dispatch(fetchUsers({
                  page: pagination.page,
                  limit: pagination.limit,
                  search: searchQuery,
                  status: filterType === "all" ? "" : filterType,
                  branchId: selectedBranch || undefined,
                }));
              }
            }}
            mode={modalMode}
            user={modalUser}
            // onFormDirty={(dirty: boolean) => handleFormDirty(dirty)}
          />
        {/* )} */}
        {
          changePasswordModalOpen && (
            <ChangePasswordModal
              isOpen={changePasswordModalOpen}
              onClose={()=> setChangePasswordModalOpen(false)}
              mode={modalMode}
              user={modalUser}
            />
          )
        }
        

          {closeDialog && (
            <CloseConfirmationDialogue
              open={closeDialog}
              onClose={() => setCloseDialog(false)}
              onConfirm={() => {
                setCloseDialog(false);
                setShowUserModal(false);
                setModalUser(null);
                setIsFormFilled(false);
                if(!USE_STUB_DATA){
                  dispatch(fetchUsers({
                    page: pagination.page,
                    limit: pagination.limit,
                    search: searchQuery,
                    status: filterType === "all" ? "" : filterType,
                    branchId: selectedBranch || undefined,
                  }));
                }
              }}
              title=""
              message="Are you sure you want to close this user model?"
            />
          )}

        {/* <CreateUserModal 
          isOpen={showCreateModal || showEditModal} // Show modal if creating or editing
          onClose={() => {
            setShowCreateModal(false);
            handleCloseEditModal();
          }}
          user={selectedUser }
        /> */}
      {/* </div> */}
      </div>
    );
    
  };

  export default UserManager;
